export default __webpack_public_path__ + "static/media/Me2.b0cf26cb.jpg";